module.exports = "https://store.zigzag.kr/resources/arm64/20260313-1604-1298abaedd_store/_next/static/images/MedalGold-67d427e62f4a62d9e05fff319ca044f1.png";